module.exports = __webpack_public_path__ + "img/vchasno.1935d8f8.png";